import { Component } from '@angular/core'
/**
 * Represents an export dialog section
 */
@Component({
  selector: 'ngx-export-section',
  templateUrl: './export-section.component.html',
  styleUrls: ['./export-section.component.scss'],
  standalone: true
})
export class ExportSectionComponent {}
